const promiseHandler = <T>(p: Promise<T>) => {
  return p.then((data) => [data, undefined]).catch((error) => Promise.resolve([undefined, error]))
}

export default promiseHandler
